import { sendGetRequest } from '@/services/api.service'
import { API_RADAR } from '@/config/api.config'

export const getSettings = (brandUuId, urlParams) => {
  return sendGetRequest(
    `${API_RADAR.DEFAULT_API_URL}${API_RADAR.SETTINGS_API_URL}?token=${API_RADAR.DEFAULT_TOKEN}&brand_uuid=${brandUuId}${urlParams}`
  )
}

export const getBrands = (brandUuId, kpi, withCompetitor, urlParams) => {
  return sendGetRequest(
    `${API_RADAR.DEFAULT_API_URL}${API_RADAR.BRANDS_API_URL}?token=${API_RADAR.DEFAULT_TOKEN}&brand_uuid=${brandUuId}&competitor=${withCompetitor}&kpis=${kpi}${urlParams}`
  )
}

export const getFilters = (brandUuId, kpi, urlParams) => {
  return sendGetRequest(
    `${API_RADAR.DEFAULT_API_URL}${API_RADAR.FILTERS_API_URL}?token=${API_RADAR.DEFAULT_TOKEN}&brand_uuid=${brandUuId}&kpis=${kpi}${urlParams}`
  )
}

export const getSearch = (brandUuId, kpi, urlParams) => {
  return sendGetRequest(
    `${API_RADAR.DEFAULT_API_URL}${API_RADAR.SEARCH_API_URL}?token=${API_RADAR.DEFAULT_TOKEN}&brand_uuid=${brandUuId}&kpis=${kpi}${urlParams}`
  )
}

export const getSources = (brandUuId, kpi, urlParams = '') => {
  return sendGetRequest(
    `${API_RADAR.DEFAULT_API_URL}${API_RADAR.SOURCES_API_URL}?token=${API_RADAR.DEFAULT_TOKEN}&brand_uuid=${brandUuId}&kpis=${kpi}${urlParams}`
  )
}

export const getDistributions = (brandUuId, kpi, urlParams = '') => {
  return sendGetRequest(
    `${API_RADAR.DEFAULT_API_URL}${API_RADAR.DISTRIBUTIONS_API_URL}?token=${API_RADAR.DEFAULT_TOKEN}&brand_uuid=${brandUuId}&kpis=${kpi}${urlParams}`
  )
}

export const getLocations = (brandUuId, kpi, urlParams = '') => {
  return sendGetRequest(
    `${API_RADAR.DEFAULT_API_URL}${API_RADAR.LOCATIONS_API_URL}?token=${API_RADAR.DEFAULT_TOKEN}&brand_uuid=${brandUuId}&kpis=${kpi}${urlParams}`
  )
}

export const getZones = (brandUuId, kpi, urlParams = '') => {
  return sendGetRequest(
    `${API_RADAR.DEFAULT_API_URL}${API_RADAR.ZONES_API_URL}?token=${API_RADAR.DEFAULT_TOKEN}&brand_uuid=${brandUuId}&kpis=${kpi}${urlParams}`
  )
}

export const getSubDivisions = (brandUuId, kpi, urlParams = '') => {
  return sendGetRequest(
    `${API_RADAR.DEFAULT_API_URL}${API_RADAR.SUB_DIVISIONS_API_URL}?token=${API_RADAR.DEFAULT_TOKEN}&brand_uuid=${brandUuId}&kpis=${kpi}${urlParams}`
  )
}

export const getExportLink = (brandUuId, urlParams, routeName) => {
  if (routeName === 'zones') {
    return `${API_RADAR.DEFAULT_API_URL}${API_RADAR.ZONES_API_URL}?token=${API_RADAR.DEFAULT_TOKEN}&brand_uuid=${brandUuId}${urlParams}`
  }
  return `${API_RADAR.DEFAULT_API_URL}${API_RADAR.LOCATIONS_API_URL}?token=${API_RADAR.DEFAULT_TOKEN}&brand_uuid=${brandUuId}${urlParams}`
}

export const getAnalytics = (brandUuId, kpi, urlParams = '') => {
  return sendGetRequest(
    `${API_RADAR.DEFAULT_API_URL}${API_RADAR.KPIS_API_URL}?token=${API_RADAR.DEFAULT_TOKEN}&brand_uuid=${brandUuId}&kpis=${kpi}${urlParams}`
  )
}
